module.exports = __webpack_public_path__ + "img/ic_org_chart_24px.e82b2d5b.png";